import Client from '../HttpClient';

const baseUrl = '/gateway/eagle-mgt/api/vs/grab/posIntegration';

// 获取OAuth重定向URL
const getOAuthUrl = (merchantId, branchId) => {
	return Client.post(`${baseUrl}/${merchantId}/pos_data`, {
		branchId,
	});
};

// 获取门店绑定状态
const branchStatus = (merchantId, branchId, companyCode = 'Grab') => {
	return Client.get(
		`/gateway/eagle-mgt/api/vs/manage-cooperation/${merchantId}/onlineCooperationCompanyRelations`,
		{ branchId, companyCode }
	);
};

// 解绑门店 (旧版本)
const unbind = (merchantId, branchId, operateBy) => {
	return Client.post(`${baseUrl}/${merchantId}/unbind`, {
		branchId,
		operateBy,
	});
};

// 解绑门店 (新版本)
const removePosData = (merchantId, branchId) => {
	return Client.post(`${baseUrl}/${merchantId}/pos_data/remove`, {
		branchId,
	});
};

export default {
	getOAuthUrl,
	branchStatus,
	unbind,
	removePosData,
};
